import { render, staticRenderFns } from "./addSubStockCode.vue?vue&type=template&id=324c47d6&"
import script from "./addSubStockCode.vue?vue&type=script&lang=js&"
export * from "./addSubStockCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports